import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import {makeToolTipUrl} from "utils/DBUtils";
import {enUSmessage} from 'i18n/en-US.js';

export const BreakPermalinkToolTip = (props) => (
  <div>
    A <strong>unique identifier</strong> that appears at the end of a site's URL.
    <br/>
    Ex: www.dailybreak.com/break/<strong>my-first-super-cool-break</strong>
    <ul>
      <li>Use keywords</li>
      <li>All lowercase</li>
      <li>No spaces</li>
      <li>Only separated by hyphens</li>
      <li>Do not duplicate any other previous URLs created</li>
    </ul>
    <img src={makeToolTipUrl('break/general/1-permalink.jpg')} width="100%"/>
  </div>
);

export const BreakTitleToolTip = (props) => (
  <div>
    The name of the break.  Featured on site homepages and the landing page of sponsored breaks.
    <br/>
    <img src={makeToolTipUrl('break/general/2.CMS-Break-title-headline.png')} width="100%"/>
    <br/>
    <img src={makeToolTipUrl('break/general/3.CMS-Break-title.png')} width="100%"/>
  </div>
);

export const BreakPageTitleToolTip = (props) => (
  <div>
    Copy that is displayed on search engine results pages as the clickable headline. Should differ from break title and best to include many key words to increase search results.
  </div>
);

export const BreakMetaDescriptionToolTip = (props) => (
  <div>
    Brief, SEO copy describing the break. This copy will appear in the body of search engine results.
    <br/>
    <img src={makeToolTipUrl('break/general/5.CMS-Break-meta.png')} width="100%"/>
  </div>
);

export const BreakSocialDescriptionToolTip = (props) => (
  <div>
    Brief, witty copy describing the break. This copy will appear in step’s “Facebook share description”.
    <br/>
    <img src={makeToolTipUrl('break/general/4.CMS-Break-social-description.png')} width="100%"/>
  </div>
);

export const BreakEditLandingPageFieldsToolTip = (props) => (
  <div>
    <IntlProvider locale="en" messages={enUSmessage}>
      <FormattedMessage id='tooltips.break.general.edit_landing_page_fields'  />
    </IntlProvider>
  </div>
);

export const BreakLandingPageHeadlineToolTip = (props) => (
  <div>
    The title of a landing page. If no copy is added here, it will automatically pull from the “Break Title” field.
    <br/>
    <img src={makeToolTipUrl('break/general/2.CMS-Break-title-headline.png')} width="100%"/>
  </div>
);

export const BreakLandingPageHeadlineMobileToolTip = (props) => (
  <div>
    The title of a mobile landing page. If no copy is added here, it will automatically pull from the “Break Title” field. Used to optimize viewing on a mobile platform, should be much shorter.
    <br/>
    <img src={makeToolTipUrl('break/general/6.CMS-landing-page-headline-mobile.png')} width="100%"/>
  </div>
);

export const BreakLandingPageIntroCopyToolTip = (props) => (
  <div>
    Witty, succinct copy describing the break. Appears at the top of the landing page.
    <br/>
    <img src={makeToolTipUrl('break/general/7.CMS-landing-page-intro-copy.png')} width="100%"/>
  </div>
);

export const BreakLandingPageMobileIntroCopyToolTip = (props) => (
  <div>
    Shortened witty copy describing the break. This will appear on the mobile landing page of sponsored break. Used to optimize viewing on a mobile platform, should be much shorter for call to action.
    <br/>
    <img src={makeToolTipUrl('break/general/8.CMS-landing-page-intro-mobile.png')} width="100%"/>
  </div>
);

export const BreakPublishDateTimeToolTip = (props) => (
  <div>
    The date and time a break will be published to a site. If “No,” date and time will be set upon publishing.
  </div>
);

export const BreakArchiveDateTimeToolTip = (props) => (
  <div>
    The date and time a break will be unpublished from a site. If “No,” the break will live on site indefinitely.
  </div>
);

export const BreakAuthorNameToolTip = (props) => (
  <div>
    The user who created the content. Sponsored breaks do not have authors.
    <br/>
    <img src={makeToolTipUrl('break/general/9.CMS-Author-name.png')} width="100%"/>
  </div>
);

export const BreakSponsorNameToolTip = (props) => (
  <div>
    The client sponsoring the break. This field is not necessary unless the client requests their name to appear in the break. Appears below landing page intro copy.
    <br/>
    <img src={makeToolTipUrl('break/general/10.CMS-Sponsor-name.png')} width="100%"/>
  </div>
);

export const BreakSocialShareToolTip = (props) => (
  <div>
    Turns on social (Facebook, Twitter, Pinterest, Email, and Print) for every shareable step.
  </div>
);

export const BreakShowFBCommentsToolTip = (props) => (
  <div>
    If yes, Facebook comment board widget will appear at the bottom of the break.
  </div>
);

export const BreakPixelToolTip = (props) => (
  <div>
    Added code to track users entering the landing page.
  </div>
);

export const CCPADataSharingToolTip = (props) => (
  <div>
    <p>Include the name and address of any company that will receieve this break's data. e.g. if we're delivering reports with non-aggregate data we need to include that entity here.</p>
    <p>Per the California Consumer Protection Act (CCPA) we need to inform residents of California with any other 3rd parties who may have the consumer's personal data.</p>
    <p>This is a free-text field and will be delivered to consumers AS-IS if they request their personal information.</p>
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/general-tool-tips.jsx